import $ from "jquery";
import './jquery.nselect.min'


let structuredPeriod = $('#structured-period')
let amount = $('#amount')
let structuredAmount = $('#structured-amount')
let horizon = $('#horizon')
let structuredHorizon = $('#structured-horizon')
let percents = $('#percents')
let res1 = $('#value1')
let res2 = $('#value2')
setTimeout(() => {

    $('.nselect').nSelect({afterChange: function () {
            calculate()
        }});

    let calculate = () => {
        let sum = amount.val().replace(/\s/g, '');
        let sumStruct = amount.val().replace(/\s/g, '');

				if (period.title === 'Monthly') {
					let finPeriod = horizon.val() * 12;
					for (let i = 0; i < finPeriod; i++) {
							let res = parseInt(sum) * (percentsVal / 12);
							let resStruct = parseInt(sumStruct) * (0.08 / 12);
							sum = parseInt(sum) + res
							sumStruct = parseInt(sumStruct) + resStruct
					}
					let sumArr = sum.toFixed(2).split('.')
					let sumStructArr = sumStruct.toFixed(2).split('.')
					let sumArr1 = sumArr[0].replace(/[^\d]/g, '').replace(/\B(?=(?:\d{3})+(?!\d))/g, ' ');
					let sumStructArr1 = sumStructArr[0].replace(/[^\d]/g, '').replace(/\B(?=(?:\d{3})+(?!\d))/g, ' ');
					res1.text('$ ' + sumArr1 + '.' + sumArr[1])
					res2.text('$ ' + sumStructArr1 + '.' + sumStructArr[1])
				} else if (period.title === 'Quarterly') {
            let finPeriod = horizon.val() * 4;
            for (let i = 0; i < finPeriod; i++) {
                let res = parseInt(sum) * (percentsVal / 4);
                let resStruct = parseInt(sumStruct) * (0.08 / 4);
                sum = parseInt(sum) + res
                sumStruct = parseInt(sumStruct) + resStruct
            }
            let sumArr = sum.toFixed(2).split('.')
            let sumStructArr = sumStruct.toFixed(2).split('.')
            let sumArr1 = sumArr[0].replace(/[^\d]/g, '').replace(/\B(?=(?:\d{3})+(?!\d))/g, ' ');
            let sumStructArr1 = sumStructArr[0].replace(/[^\d]/g, '').replace(/\B(?=(?:\d{3})+(?!\d))/g, ' ');
            res1.text('$ ' + sumArr1 + '.' + sumArr[1])
            res2.text('$ ' + sumStructArr1 + '.' + sumStructArr[1])
        } else if (period.title === 'Yearly') {
            for (let i = 0; i < horizon.val(); i++) {
                let res = parseInt(sum) * percentsVal;
                let resStruct = parseInt(sumStruct) * 0.08;
                sum = parseInt(sum) + res
                sumStruct = parseInt(sumStruct) + resStruct
            }
            let sumArr = sum.toFixed(2).split('.')
            let sumStructArr = sumStruct.toFixed(2).split('.')
            let sumArr1 = sumArr[0].replace(/[^\d]/g, '').replace(/\B(?=(?:\d{3})+(?!\d))/g, ' ');
            let sumStructArr1 = sumStructArr[0].replace(/[^\d]/g, '').replace(/\B(?=(?:\d{3})+(?!\d))/g, ' ');
            res1.text('$ ' + sumArr1 + '.' + sumArr[1])
            res2.text('$ ' + sumStructArr1 + '.' + sumStructArr[1])
        }
    }
    let percentsVal = 0.03
    let period = document.getElementsByClassName('nselect__head')[0]
    structuredPeriod.text(period.title)
    structuredAmount.text('$  ' + amount.val())
    structuredHorizon.text(horizon.val() + '  years')
    res1.text('$ 134 866.33')

    $('.nselect__list li').click(function () {
        structuredPeriod.text(period.title)
    })

    percents.on('input', function () {
        percentsVal = $(this).val() * 0.01
    })

    amount.on('input', function () {
        structuredAmount.text('$  ' + $(this).val())
    })

    horizon.on('input', function () {
        structuredHorizon.text($(this).val() + '  years')
    })

    percents.on('input', function () {
        calculate()
    })

    amount.on('input', function () {
        calculate()
    })

    horizon.on('input', function () {
        calculate()
    })


    $('#calculate').click(function () {
        calculate()
    })

}, 500)
